// <frame-film>. Qué hace: sections/harness-sequence.liquid.
const C = document.documentElement.classList, M = matchMedia('(max-width: 989px)'), T = matchMedia('(pointer: coarse)'), cl = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
const keys = (s) => s.split(',').map((k) => k.split(':').map(Number));
const at = (ks, p, e) => {
  let i = 1;
  while (i < ks.length - 1 && p > ks[i][0]) i++;
  const a = ks[i - 1], b = ks[i];
  let t = cl((p - a[0]) / (b[0] - a[0] || 1));
  if (e) t = t < 0.5 ? 4 * t * t * t : 1 - (2 - 2 * t) ** 3 / 2;
  return a.map((v, j) => v + (b[j] - v) * t);
};
const SH = ['uniform vec4 c;out vec2 v;void main(){vec2 p=vec2(gl_VertexID&1,gl_VertexID>>1);v=c.xy+c.zw*p;gl_Position=vec4(p.x*2.-1.,1.-p.y*2.,0,1);}',
  'precision highp float;uniform sampler2D a,b;uniform float w;in vec2 v;out vec4 o;void main(){o=mix(texture(a,v),texture(b,v),w);}'];

customElements.define('frame-film', class extends HTMLElement {
  connectedCallback() {
    if (!C.contains('motion-ok') || this.x) return;
    const d = this.dataset, cv = (this.cv = this.querySelector('canvas')), img = this.querySelector('img');
    const segs = [...this.querySelectorAll('[data-from]')], n = +d.frames, io = (m, f) => new IntersectionObserver(f, { rootMargin: m }).observe(this);
    // Chromium: WebGL 2 (su lienzo 2D guarda en la GPU cada fotograma dibujado). Safari y Firefox: lienzo 2D.
    const g = (this.gl = navigator.userAgentData && cv.getContext('webgl2', { alpha: false, antialias: false, depth: false }));
    this.x = g || cv.getContext('2d', { alpha: false });
    if (g) {
      const P = g.createProgram();
      SH.forEach((s, i) => { const o = g.createShader(g.VERTEX_SHADER - i); g.shaderSource(o, '#version 300 es\n' + s); g.compileShader(o); g.attachShader(P, o); });
      g.linkProgram(P); g.useProgram(P);
      g.uniform1i(g.getUniformLocation(P, 'b'), 1);
      this.u = ['w', 'c'].map((k) => g.getUniformLocation(P, k));
      this.tx = [0, 1].map((i) => {
        g.activeTexture(g.TEXTURE0 + i); g.bindTexture(g.TEXTURE_2D, g.createTexture()); g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MIN_FILTER, g.LINEAR);
        g.texStorage2D(g.TEXTURE_2D, 1, g.RGBA8, +d.width, +d.height);
        return -1;
      });
    }
    this.tm = keys(d.timemap); this.cam = [keys(d.camera), keys(d.cameraMobile || d.camera)];
    this.bl = []; this.bm = []; this.dec = this.c = this.t = 0; this.s = -1;
    // Fotogramas solo después del primer scroll y con la película a cuatro pantallas (quien no baja no los descarga).
    const near = new Promise((r) => addEventListener('scroll', () => io('400% 0px', ([e], o) => e.isIntersecting && (o.disconnect(), r())), { once: true, passive: true }));
    io('100% 0px', ([e]) => {
      if (!(this.on = e.isIntersecting)) this.bm.forEach((b, j) => j !== this.frame && (b?.close?.(), delete this.bm[j]));
      this.s = -1; this.win(); this.go();
    });
    addEventListener('scroll', () => this.on && this.go(), { passive: true });
    new ResizeObserver(([e]) => {
      const r = e.contentRect, w = Math.round(r.width), h = r.height;
      if (!w || (w === this.w && h === this.h)) return;
      cv.width = Math.round(Math.min((this.w = w) * devicePixelRatio, d.width)); cv.height = Math.round((cv.width * (this.h = h)) / w);
      this.x.imageSmoothingQuality = 'high';
      this.k = ''; this.go();
    }).observe(cv);
    this.onclick = (e) => {
      const b = e.target.closest('[data-from]'), r = this.getBoundingClientRect();
      if (b) scrollTo({ top: scrollY + r.top + (b.dataset.from / 100 + 0.02) * (r.height - innerHeight), behavior: 'smooth' });
    };
    const cur = () => segs.forEach((s, j) => (j === Math.min(+d.beat || 0, segs.length - 1) ? s.setAttribute('aria-current', 'step') : s.removeAttribute('aria-current')));
    new MutationObserver(cur).observe(this, { attributeFilter: ['data-beat'] });
    cur();
    (async () => {
      await near;
      for (const st of M.matches ? [8, 4, 2] : [8, 4, 2, 1]) {
        if (!cv.offsetWidth) return;
        const q = [];
        for (let i = 0; i < n; i += st) this.bl[i] || q.push(i);
        await Promise.all([1, 2, 3, 4, 5, 6].map(async () => {
          while (q.length) {
            q.sort((a, b) => Math.abs(a - this.c) - Math.abs(b - this.c));
            const i = q.shift();
            try {
              this.bl[i] = await (await fetch(i == n - 1 && img.currentSrc || d.base.replace('001.webp', `${String(i + 1).padStart(3, '0')}.webp`), { priority: 'low' })).blob();
              this.win();
            } catch {}
          }
        }));
      }
    })();
  }

  go() {
    this.raf ||= requestAnimationFrame((t) => this.tick(t));
  }
  tick(t) {
    this.raf = 0;
    if (!C.contains('motion-ok')) return;
    const r = this.getBoundingClientRect(), g = cl(-r.top / (r.height - innerHeight)), s = this.s, gap = g - s, dt = this.t ? Math.min(64, t - this.t) : 16;
    this.s = s < 0 || Math.abs(gap) > 0.3 || Math.abs(gap) < 3e-4 ? g : s + gap * (1 - Math.exp(-dt / (T.matches ? 70 : 90)));
    const f = at(this.tm, this.s)[1];
    this.q = s < 0 || Math.abs(f - this.f) >= 1 ? 1 : Math.abs(g - this.s) > 2e-3 ? 0 : Math.min(1, this.q + dt / 150);
    this.f = f;
    this.draw();
    if ((this.t = this.s !== g || this.q < 1 ? t : 0)) this.go();
  }
  draw() {
    const g = this.gl, f = this.f, bm = this.bm, d = this.dataset, c = Math.round(f), W = this.cv.width, H = this.cv.height;
    if (g?.isContextLost()) return this.classList.remove('is-drawn');
    if (c !== this.c) { this.c = c; this.win(); }
    let a = Math.floor(f), b = a + 1, w = 0;
    while (a >= 0 && !bm[a]) a--;
    while (b < d.frames && !bm[b]) b++;
    if (!bm[a] && !bm[b]) return;
    let i = bm[a] && (!bm[b] || f - a <= b - f) ? a : b;
    if (bm[a] && bm[b] && b - a < 3) {
      w = (f - a) / (b - a);
      w += (Math.round(w) - w) * this.q;
      i = w < 0.98 ? a : b;
      if (w <= 0.02 || w >= 0.98) w = 0;
    }
    const [, cx, cy, z] = at(this.cam[+M.matches], this.s, 1), iw = +d.width, ih = +d.height;
    let sw = iw, sh = ih;
    if (W / H < iw / ih) sw = (ih * W) / H;
    else sh = (iw * H) / W;
    sw /= z; sh /= z;
    const sx = Math.min(iw - sw, Math.max(0, cx * iw - sw / 2)), sy = Math.min(ih - sh, Math.max(0, cy * ih - sh / 2)), k = [i, b, Math.round(w * 50), sx | 0, sy | 0, sw * 4 | 0, W, H].join();
    if (k === this.k) return;
    this.k = k;
    if (g) {
      const u = this.up(i, w && b);
      w && this.up(b, i);
      g.uniform1f(this.u[0], u ? 1 - w : w);
      g.uniform4f(this.u[1], sx / iw, sy / ih, sw / iw, sh / ih);
      g.viewport(0, 0, W, H); g.drawArrays(g.TRIANGLE_STRIP, 0, 4);
    } else {
      const x = this.x, put = (j) => x.drawImage(bm[j], sx, sy, sw, sh, 0, 0, W, H);
      put(i);
      if (w) { x.globalAlpha = w; put(b); x.globalAlpha = 1; }
    }
    this.frame = i; this.mix = w;
    this.classList.add('is-drawn');
  }
  up(j, keep) {
    const g = this.gl, t = this.tx;
    let u = t.indexOf(j);
    if (u < 0) {
      g.activeTexture(g.TEXTURE0 + (u = +(t[0] === keep)));
      g.texSubImage2D(g.TEXTURE_2D, 0, 0, 0, g.RGBA, g.UNSIGNED_BYTE, this.bm[j]);
      t[u] = j;
    }
    return u;
  }
  win() {
    const c = this.c, bm = this.bm;
    bm.forEach((b, j) => Math.abs(j - c) > 10 && (b?.close?.(), delete bm[j]));
    for (let s = 0; this.on && s <= 8; s++) for (const j of [c + s, c - s]) {
      if (this.dec < 4 && this.bl[j] && bm[j] == null) {
        this.dec++;
        bm[j] = 0;
        createImageBitmap(this.bl[j]).then((b) => {
          if (Math.abs(j - this.c) > 10 || bm[j] !== 0) return b.close();
          bm[j] = b; this.k = ''; this.go();
        }, () => delete this.bl[j]).finally(() => { if (bm[j] === 0) delete bm[j]; this.dec--; this.win(); });
      }
    }
  }
});
